import React from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';

const getHighlightedChunks = (chunks, highlights = []) => {
  const mainChunk = chunks[chunks.length - 1];
  if (mainChunk.highlight) return chunks;
  let highlight = '';
  let highlightIndex = mainChunk.length;
  for (let i = 0; i < highlights.length; i++) {
    const highlightIndexTmp = mainChunk.toLowerCase().indexOf(highlights[i].toLowerCase());
    if (highlightIndexTmp === -1) {
      continue;
    } else if (highlightIndexTmp < highlightIndex) {
      highlight = highlights[i].toLowerCase();
      highlightIndex = highlightIndexTmp;
    }
  }
  if (highlightIndex < mainChunk.length) {
    return getHighlightedChunks(
      compact([
        ...chunks.slice(0, chunks.length - 1),
        mainChunk.substr(0, highlightIndex),
        { highlight: mainChunk.substr(highlightIndex, highlight.length) },
        mainChunk.substr(highlightIndex + highlight.length),
      ]),
      highlights,
    );
  }
  return chunks;
};

const HighlightText = ({ color, highlight, text, ...props }) => {
  if (!highlight || !text) return <span {...props}>{text}</span>;
  const highlights = highlight.trim().split(' ');
  const chunks = getHighlightedChunks([text], highlights);
  return (
    <span {...props}>
      {chunks.map((chunk, index) => {
        if (chunk.highlight) {
          return (
            <span
              className={color ? '' : 'search-highlight'}
              key={index}
              style={color ?
                {
                  backgroundColor: color,
                  color: 'white',
                  padding: 2,
                } : null}
            >
              {chunk.highlight}
            </span>
          );
        }
        return <span key={index}>{chunk}</span>;
      })}
    </span>
  );
};

HighlightText.propTypes = {
  color: PropTypes.string,
  highlight: PropTypes.string,
  text: PropTypes.string,
};

HighlightText.defaultProps = {
  color: null,
  highlight: '',
  text: '',
};

export default HighlightText;
